import axios from 'axios';
import { DashboardUser, Position } from '../types';

const API_BASE_URL = 'https://vlad.voxlink.ru/api';

// Создаем отдельный экземпляр axios для публичных запросов без токена
const publicApi = axios.create({
  baseURL: API_BASE_URL,
});

export const publicAPI = {
  getDashboardData: async (city?: string): Promise<{ users: DashboardUser[] }> => {
    const params = city ? { city } : {};
    const response = await publicApi.get('/public/dashboard', { params });

    // Получаем информацию о должностях для отображения названий
    try {
      const positionsResponse = await publicApi.get('/public/positions');
      const positions = positionsResponse.data;
      const positionMap = new Map(positions.map((p: Position) => [p.id, p.title]));

      // Фильтруем пользователей, исключая тех с ролью 'guest'
      const filteredUsers = response.data.filter((user: any) => user.role !== 'guest');

      return {
        users: filteredUsers.map((user: any) => {
          // Обрабатываем компетенции - если это массив, конвертируем в строку
          let competencies = user.competencies;
          if (Array.isArray(competencies)) {
            competencies = competencies.join(', ');
          }

          const result = {
            ...user,
            competencies,
            position: user.position_id && positionMap.get(user.position_id) ? positionMap.get(user.position_id) : undefined
          };

          // Отладка
          console.log('🔍 Processing user:', {
            id: user.id,
            role: user.role,
            original_competencies: user.competencies,
            parsed_competencies: competencies,
            result_competencies: result.competencies
          });

          return result;
        })
      };
    } catch (error) {
      console.error('Failed to load positions for public dashboard:', error);
      // Если не удалось получить должности, возвращаем данные без них, но все равно фильтруем гостей
      return {
        users: response.data
          .filter((user: any) => user.role !== 'guest')
          .map((user: any) => {
            let competencies = user.competencies;
            if (typeof competencies === 'string') {
              try {
                competencies = JSON.parse(competencies);
              } catch (e) {
                competencies = null;
              }
            }
            return { ...user, competencies };
          })
      };
    }
  },

  getCities: async (): Promise<string[]> => {
    const response = await publicApi.get('/public/cities');
    return response.data;
  },

  getPositions: async (): Promise<Position[]> => {
    const response = await publicApi.get('/public/positions');
    return response.data;
  },

  getEmployeeStatuses: async (): Promise<Record<string, {
    name: string;
    phone: string;
    redis_status: string;
    emoji: string;
    available: number;
    city: string;
    role: string;
  }>> => {
    const response = await publicApi.get('/public/employee-statuses');
    return response.data;
  },
};

export default publicApi;